module.exports = __webpack_public_path__ + "img/monitoring.35d5b0b.svg";